import { boot } from "quasar/wrappers";
import WhiteLabelController from "../controllers/WhiteLabelController";

export const WhiteLabelControllerInstance = new WhiteLabelController();

export default boot(({ app }) => {
  app.config.globalProperties.$WhiteLabelController =
    WhiteLabelControllerInstance;
});
